<div class="timeSelector__cont">
  <span *ngFor="let time of roomRate?.CheckinTimes" class="timeSelector__cont__item">
    <span>{{ time }}</span>
    <p 
      [id]="'time-selector-' + time"
      [class.active]="selectedValue === time"
      (click)="selected.emit(time)">
    </p>
  </span>
</div>